module.exports = __webpack_public_path__ + "media/images/ISO9001-96aa164372cc6370dff5ddcbea3144bb.png";